import { CardPassThroughOptions, CardProps } from 'primereact/card';
import { classNames } from 'primereact/utils';

export const PTCard: CardPassThroughOptions = {
  root: {
    className: 'ax-card overflow-hidden',
  },
  body: {
    className: 'ax-card__body',
  },
  title: {
    className: 'ax-card__body__title ax-card-title-p',
  },
  subTitle: {
    className: 'ax-card__body__subtitle',
  },
  content: ({ props }: { props: CardProps }) => ({
    className: classNames('ax-card__body__content', {
      'ax-card-content-full-p': !props.title,
      'ax-card-content-p': props.title,
    }),
  }),
  footer: {
    className: 'ax-card__body__footer px-3 pb-3 relative bottom-0 left-0',
  },
};
